import axios from './dataClient'

import { getRuntimeEnv } from '../runtimeEnv'

const BASE_URL = getRuntimeEnv('REACT_APP_API_URL', 'http://localhost:3000')

export const postPropertyData = (address, unit) => {
  return axios.post(`${BASE_URL}/property-data`, { address, unit })
}

export const postPropertyOwners = (address, unit, firstName, lastName, companyName, formattedAddress) => {
  return axios.post(`${BASE_URL}/property-owner`, { address, unit, firstName, lastName, companyName, formattedAddress })
}

export const postFOIData = foiData => {
  const config = foiData instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}

  return axios.post(`${BASE_URL}/foi`, foiData, config)
}

export const postAddressData = addressData => {
  return axios.post(`${BASE_URL}/address`, addressData)
}

export const postFile = (foiId, file, usage, addressId) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('usage', usage)
  if (usage === 'ADDRESS') formData.append('addressId', addressId)

  return axios.post(`${BASE_URL}/file/${foiId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const postPIRData = pirData => {
  return axios.post(`${BASE_URL}/pir`, pirData)
}

export const getPaymentIntentSecret = async (associationId, associationType) => {
  // TODO: need to somehow useSearchParams in PaymentPage.stories to get some mocked pirId there. meanwhile
  // commenting out the error
  // if (!pirId) throw new Error('pirId missing from payment request')
  return axios.post(`${BASE_URL}/payment`, { associationId, associationType })
}

export const getPIRById = pirId => {
  return axios.get(`${BASE_URL}/pir/${pirId}`)
}

export const getPIRStatus = (pirId, recipient) => {
  const params = recipient ? { recipient } : {}
  return axios.get(`${BASE_URL}/pir/${pirId}/status`, { params })
}

export const getFOIStatus = foiId => {
  return axios.get(`${BASE_URL}/foi/${foiId}/status`)
}

export const getPIRFileList = pirId => {
  return axios.get(`${BASE_URL}/pir/${pirId}/fileList`)
}

export const getTierInformation = () => {
  return axios.get(`${BASE_URL}/pir/tierInformation`)
}

export const getAdditionalDetailsInformation = () => {
  return axios.get(`${BASE_URL}/pir/additionalDetailsInformation`)
}

export const getBillById = billId => {
  return axios.get(`${BASE_URL}/bill/${billId}`)
}

export const getBillDownload = billId => {
  return axios.get(`${BASE_URL}/bill/${billId}/download`, { responseType: 'blob' })
}

export const getBillDownloadReceipt = billId => {
  return axios.get(`${BASE_URL}/bill/${billId}/download-receipt`, { responseType: 'blob' })
}

export const postUploadPIRFile = (pirId, file, isSignature, authorizer) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('isSignature', isSignature)
  formData.append('authorizer', authorizer)

  return axios.post(`${BASE_URL}/upload/${pirId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const postPIRResponseEmail = pirId => {
  return axios.post(`${BASE_URL}/pir/${pirId}/response`)
}

export const postSecurityCode = (requestId, requestType, generate, recipient) => {
  return axios.post(`${BASE_URL}/security-code`, { associationId: requestId, associationType: requestType.toUpperCase(), generate, recipient })
}

export const postVerifySecurityCode = (requestId, requestType, code, recipient) => {
  return axios.post(`${BASE_URL}/verify-security-code`, {
    associationId: requestId,
    associationType: requestType.toUpperCase(),
    code,
    recipient
  })
}

export const postLogin = (email, password) => {
  return axios.post(`${BASE_URL}/user/login`, { email, password })
}

export const postResetPassword = email => {
  return axios.post(`${BASE_URL}/user/reset`, { email })
}

export const postUpdatePassword = (token, password) => {
  return axios.post(`${BASE_URL}/user/update`, { token, password })
}

export const postCancelFOI = (foiId, body) => {
  return axios.post(`${BASE_URL}/foi/${foiId}/cancel`, body)
}

export const postRejectBill = billId => {
  return axios.post(`${BASE_URL}/bill/${billId}/reject`)
}

export const postInPersonApplicationFee = (foiId, billId) => {
  return axios.post(`${BASE_URL}/foi/${foiId}/bill/${billId}/in-person-application-fee`)
}

export const postFoiNotValidRequest = foiId => {
  return axios.post(`${BASE_URL}/foi/${foiId}/not-valid-request`)
}

export const postBillRefundInPerson = billId => {
  return axios.post(`${BASE_URL}/bill/${billId}/refund-in-person`)
}

export const postBillRefund = billId => {
  return axios.post(`${BASE_URL}/bill/${billId}/refund`)
}
